import { type ObjectValuesUnionType } from '../utils/typing';

export const SocketEvents = Object.freeze({
  CONNECT: 'connect',
  CONNECT_ERROR: 'connect_error',
  RECONNECTING: 'reconnecting',
  DISCONNECT: 'disconnect',
  MESSAGE: 'm',

  SEND: 'send', // custom event for unit tests
});

export type SocketEvent = ObjectValuesUnionType<typeof SocketEvents>;
